export const TimeOut = 120 * 1000;
export const AppInfo = {
    title: "Devextreme Vue3",
};